import AccountCircle from "@mui/icons-material/AccountCircle";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";

const TopBar = ({ logout }) => {
  const [userInfo, setUserInfo] = useState({});
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  

  // const handleDrawerClose = () => {
  //   setOpen(false);
  // };

  const handleLogoutOnClik = () => {
    logout();
    // setOpen(false);
  };

  // const handleChange = (event) => {
  //   setAuth(event.target.checked);
  // };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const userStorageValue = localStorage.getItem("user");
    setUserInfo(JSON.parse(userStorageValue));
    console.log(
      "userStorageValue",
      typeof userStorageValue,
      JSON.parse(userStorageValue)
    );
  }, []);
  return (
    <>
     
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          alignItems: "center",
        }}
      >
     <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="h6" noWrap component="div">
            {process.env.REACT_APP_APPNAME}
          </Typography>
          <Typography variant="subtitle2" noWrap component="div" sx={{ml:3, color: "#f7e2e2"}}>
              Next Generation Dental Clinic Management System. 
          </Typography>
        </Box>

        {/* right side profile  */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="subtitle" noWrap component="div">
            Welcome, {userInfo?.name}
          </Typography>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit"
          >
            <AccountCircle />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={handleClose}>Profile</MenuItem>
            <MenuItem onClick={handleLogoutOnClik}>Logout</MenuItem>
          </Menu>
        </Box>
        {/* right side profile  */}
      </Box>
    </>
  );
};

export default TopBar;
